import type { ReactNode, CSSProperties } from 'react';
import classNames from 'classnames';
import type { SubtitleStyleOptions } from '../language-menu/language-menu.types';

import styles from './subtitles.module.css';

type Props = {
  withSpaceForBottomBar?: boolean;
  children?: ReactNode;
  wrapperWidth?: number;
  subtitleStyleOptions?: SubtitleStyleOptions;
};

export function Subtitles({ withSpaceForBottomBar, children, wrapperWidth = 0, subtitleStyleOptions }: Props) {
  const [fontFamily, fontVariant] = subtitleStyleOptions?.fontFamily?.split('|') || [];

  return (
    <div
      data-testid="subtitle"
      className={classNames(styles.subtitles, { [styles.withSpaceForBottomBar]: withSpaceForBottomBar })}
      style={
        {
          '--subtitleFontColor': subtitleStyleOptions?.fontColor,
          '--subtitleBackgroundColor': subtitleStyleOptions?.backgroundColor,
          '--subtitleBackgroundTransparency': subtitleStyleOptions?.backgroundTransparency,
          '--subtitleFontSize': subtitleStyleOptions?.fontSize,
          '--subtitleFontFamily': fontFamily,
          '--subtitleFontVariant': fontVariant || 'normal',
          '--wrapperWidth': wrapperWidth,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
}
